<please-wait *ngIf="!liste"></please-wait>
<list-view [liste]="liste" *ngIf="liste"></list-view>